import React from 'react';
import { ThemeContext } from 'styled-components';
import { Overlay } from '../Popoverlay';
import * as S from './styles';
import { IPopoverProps } from './types';

export const Popover: React.FC<IPopoverProps> = ({
  appearance = 'filled',
  ...props
}) => {
  const theme = React.useContext(ThemeContext);
  const arrowSize = parseInt(theme.popover.arrowSize as string, 10);
  const arrowRound = Math.round(-arrowSize - arrowSize / 2);
  return (
    <Overlay
      target={props.children}
      placement={props.placement}
      triggers={props.triggers}
      style={props.style}
      className={props.className}
      eventListener={props.eventListener}
      transformSize={10}
      arrowRound={arrowRound}
      arrowSize={theme.popover.arrowSize as string}
    >
      <S.Popover appearance={appearance}>
        <span className="arrow" />
        {typeof props.overlay === 'string' ? (
          <div className="primitive-overlay">{props.overlay}</div>
        ) : (
          props.overlay
        )}
      </S.Popover>
    </Overlay>
  );
};
